/* ag-v81.js - AquaGrip CT (v81, 27 Oct 2026, Claude)
   1. Studio close: lock the page while the Studio overlay is open (iPhone
      scrolled the page underneath, so closing landed mid-page), and return
      to the top when it closes.
   2. "Customer builds" photo grid -> tap-to-view lightbox (v88: the grid is a
      photo wall again, see ag-v88.*; the swipe carousel is no longer used).
   3. "The terms, plainly" -> one tidy open/close panel.
   Touches no cart form and no studio code: it wraps AGStudio.open/close. */
(function(){
  'use strict';
  if(window.__agv81) return; window.__agv81 = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1. studio open/close ---------- */
  function wrapStudio(){
    var S = window.AGStudio;
    if(!S || S.__agv) return !!S;
    S.__agv = true;
    var open = S.open, close = S.close;
    S.open = function(){
      document.documentElement.classList.add('agv-locked');
      return open.apply(this, arguments);
    };
    S.close = function(){
      var r = close.apply(this, arguments);
      document.documentElement.classList.remove('agv-locked');
      window.scrollTo(0, 0);
      return r;
    };
    /* the overlay's own Close button was bound to the original close */
    var btn = document.getElementById('agsClose');
    if(btn) btn.addEventListener('click', function(){
      document.documentElement.classList.remove('agv-locked');
      setTimeout(function(){ window.scrollTo(0, 0); }, 0);
    });
    /* if the overlay is already open (deep link opened it first) */
    var ov = document.getElementById('agsOverlay');
    if(ov && ov.classList.contains('on')) document.documentElement.classList.add('agv-locked');
    if(ov && 'MutationObserver' in window){
      new MutationObserver(function(){
        if(ov.classList.contains('on')) document.documentElement.classList.add('agv-locked');
        else if(document.documentElement.classList.contains('agv-locked')){
          document.documentElement.classList.remove('agv-locked'); window.scrollTo(0, 0);
        }
      }).observe(ov, {attributes:true, attributeFilter:['class']});
    }
    return true;
  }
  var tries = 0;
  (function waitStudio(){ if(wrapStudio() || ++tries > 120) return; setTimeout(waitStudio, 150); })();

  /* ---------- 2. photo carousel + lightbox ---------- */
  var lb, lbImg, lbCount, lbList = [], lbIdx = 0;
  function lightbox(){
    if(lb) return;
    lb = document.createElement('div'); lb.className = 'agv-lb'; lb.setAttribute('role','dialog'); lb.setAttribute('aria-modal','true');
    lb.innerHTML = '<img alt=""><button type="button" class="agv-lb-x" aria-label="Close">✕</button>' +
      '<button type="button" class="agv-lb-p" aria-label="Previous photo">←</button>' +
      '<button type="button" class="agv-lb-n" aria-label="Next photo">→</button><div class="agv-lb-c"></div>';
    document.body.appendChild(lb);
    lbImg = lb.querySelector('img'); lbCount = lb.querySelector('.agv-lb-c');
    lb.querySelector('.agv-lb-x').addEventListener('click', hide);
    lb.querySelector('.agv-lb-p').addEventListener('click', function(e){ e.stopPropagation(); show(lbIdx - 1); });
    lb.querySelector('.agv-lb-n').addEventListener('click', function(e){ e.stopPropagation(); show(lbIdx + 1); });
    lb.addEventListener('click', function(e){ if(e.target === lb) hide(); });
    document.addEventListener('keydown', function(e){
      if(!lb.classList.contains('is-on')) return;
      if(e.key === 'Escape') hide();
      if(e.key === 'ArrowRight') show(lbIdx + 1);
      if(e.key === 'ArrowLeft') show(lbIdx - 1);
    });
    var sx = 0;
    lb.addEventListener('touchstart', function(e){ sx = e.touches[0].clientX; }, {passive:true});
    lb.addEventListener('touchend', function(e){ var dx = e.changedTouches[0].clientX - sx; if(Math.abs(dx) > 45) show(lbIdx + (dx < 0 ? 1 : -1)); }, {passive:true});
  }
  function bigSrc(img){
    var set = (img.getAttribute('srcset') || '').split(',').map(function(s){ return s.trim().split(' ')[0]; }).filter(Boolean);
    var src = set.length ? set[set.length - 1] : img.currentSrc || img.src;
    return src.replace(/([?&])width=\d+/, '$1width=1800');
  }
  function show(i){
    if(!lbList.length) return;
    lbIdx = (i + lbList.length) % lbList.length;
    var img = lbList[lbIdx];
    lbImg.src = bigSrc(img); lbImg.alt = img.alt || '';
    lbCount.textContent = (lbIdx + 1) + ' / ' + lbList.length;
  }
  function hide(){ lb.classList.remove('is-on'); document.documentElement.style.overflow = ''; }

  function carousel(grid){
    if(grid.__agv) return; grid.__agv = true;
    var slides = Array.prototype.slice.call(grid.children);
    if(slides.length < 2) return;
    var wrap = document.createElement('div'); wrap.className = 'agv-car';
    grid.parentNode.insertBefore(wrap, grid); wrap.appendChild(grid);
    grid.classList.add('agv-track');
    var bar = document.createElement('div'); bar.className = 'agv-bar';
    bar.innerHTML = '<button type="button" class="agv-btn" aria-label="Previous photos">←</button><span class="agv-count"></span><button type="button" class="agv-btn" aria-label="Next photos">→</button>';
    wrap.appendChild(bar);
    var prev = bar.children[0], count = bar.children[1], next = bar.children[2];
    function current(){
      var mid = grid.scrollLeft + grid.clientWidth / 2, best = 0, bd = Infinity;
      slides.forEach(function(s, k){ var c = s.offsetLeft + s.offsetWidth / 2, d = Math.abs(c - mid); if(d < bd){ bd = d; best = k; } });
      return best;
    }
    function go(k){
      k = Math.max(0, Math.min(slides.length - 1, k));
      var s = slides[k];
      grid.scrollTo({left: s.offsetLeft - (grid.clientWidth - s.offsetWidth) / 2, behavior: reduce ? 'auto' : 'smooth'});
    }
    function paint(){
      var k = current();
      count.textContent = (k + 1) + ' / ' + slides.length;
      prev.disabled = grid.scrollLeft <= 2;
      next.disabled = grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 2;
    }
    prev.addEventListener('click', function(){ go(current() - 1); });
    next.addEventListener('click', function(){ go(current() + 1); });
    var raf = 0;
    grid.addEventListener('scroll', function(){ if(raf) return; raf = requestAnimationFrame(function(){ raf = 0; paint(); }); }, {passive:true});
    window.addEventListener('resize', paint);
    paint();
    /* tap a photo -> lightbox */
    var imgs = slides.map(function(s){ return s.querySelector('img'); }).filter(Boolean);
    imgs.forEach(function(img, k){
      img.parentNode.setAttribute('tabindex', '0');
      img.parentNode.setAttribute('role', 'button');
      img.parentNode.setAttribute('aria-label', 'View photo ' + (k + 1) + ' of ' + imgs.length);
      function openIt(){ lightbox(); lbList = imgs; show(k); lb.classList.add('is-on'); document.documentElement.style.overflow = 'hidden'; }
      img.parentNode.addEventListener('click', openIt);
      img.parentNode.addEventListener('keydown', function(e){ if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); openIt(); } });
    });
  }

  /* ---------- 3. terms toggle ---------- */
  function terms(box){
    if(box.closest('.agv-terms')) return;
    var label = box.querySelector('.ag-eyebrow');
    var d = document.createElement('details'); d.className = 'agv-terms';
    var s = document.createElement('summary'); s.textContent = label ? label.textContent : 'The terms, plainly';
    box.parentNode.insertBefore(d, box); d.appendChild(s); d.appendChild(box);
  }

  /* v88: "Customer builds" is a photo wall again (Chris: the carousel on the
     ocean video looked dated). The wall layout + hover effects live in
     ag-v88.css / ag-v88.js; this just wires each photo to the lightbox.
     carousel() above is kept but no longer called. */
  function wall(grid){
    if(grid.__agv) return; grid.__agv = true;
    grid.classList.add('agv-wall');
    var imgs = Array.prototype.slice.call(grid.querySelectorAll('img'));
    imgs.forEach(function(img, k){
      var f = img.closest('figure') || img.parentNode;
      f.setAttribute('tabindex', '0');
      f.setAttribute('role', 'button');
      f.setAttribute('aria-label', 'View photo ' + (k + 1) + ' of ' + imgs.length);
      function openIt(){ lightbox(); lbList = imgs; show(k); lb.classList.add('is-on'); document.documentElement.style.overflow = 'hidden'; }
      f.addEventListener('click', openIt);
      f.addEventListener('keydown', function(e){ if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); openIt(); } });
    });
  }

  function init(){
    Array.prototype.forEach.call(document.querySelectorAll('.ag-work .ag-work-grid'), wall);
    Array.prototype.forEach.call(document.querySelectorAll('.ag-flow .ag-terms'), terms);
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
